import { render, staticRenderFns } from "./PlgCampaigns.vue?vue&type=template&id=0f91a093&"
import script from "./PlgCampaigns.vue?vue&type=script&lang=js&"
export * from "./PlgCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./PlgCampaigns.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports